import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';

function UserInfo({ user }) {
  if (!user) return null;

  return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Avatar
        alt={user.admin_name}
        src={user.admin_image}
        sx={{ width: 80, height: 80, margin: '0 auto' }}
      />
      <Typography variant="h6" sx={{ mt: 1 }}>
        {user.admin_name}
      </Typography>
      {Array.isArray(user.admin_roles) && user.admin_roles.length > 0 && (
        <Typography variant="body2" color="textSecondary">
          {user.admin_roles.map(r => r.role_name || r).join(', ')}
        </Typography>
      )}
    </Box>
  );
}

export default UserInfo;
